import { combineReducers } from 'redux';

import { ANALYTICS_ENABLE, ANALYTICS_DISABLE } from './constants';

const enabled = (state = false, action) => {
    switch (action.type) {
        case ANALYTICS_ENABLE:
            return true;
        case ANALYTICS_DISABLE:
            return false;
        default:
            return state;
    }
};

export default combineReducers({ enabled });



// WEBPACK FOOTER //
// ./src/services/google/analytics/reducer.js